const data = [
  {
    id: 1,
    text: 'github',
    url: 'https://www.github.com/',
  },
  {
    id: 2,
    text: 'frontendmentor',
    url: 'https://frontendmentor.io/',
  },
  {
    id: 3,
    text: 'linkedin',
    url: 'https://linkedin.com/',
  },
  {
    id: 4,
    text: 'twitter',
    url: 'https://twitter.com/',
  },
];

export default data;
